module.exports = __webpack_public_path__ + "img/lw.1a61e205.jpg";